/**
 * Created by Kirill Mashchenko on 17.05.23.
 */

/**
 * @class Layer for physical press robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var PressRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends PressRobotSettingsLayer# */{
	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Press") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
